import React,{useState,useEffect} from "react";
import { Button, Col, Container, Row,Modal,ModalBody,ModalFooter,ModalHeader } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Table from "./components/SubcriptionTable";
import Content from './components/email_content'
import './components/style.css'
import {sendNewsLetter} from '../../redux/middlewares/Jobs/post_job'
import store from '../../containers/App/store'
import {connect} from 'react-redux'
import { toast } from "react-toastify";

const DataTable = ({ t,sendNewsLetter,news_letter_succes }) =>  {

  useEffect(() => {
    console.log(news_letter_succes)
    if(news_letter_succes === true){
    setLoading(false);
    setIsOpen(!isOpen)
    toast.success("Successfully email sent to all subscriber!")
    }
  }, [news_letter_succes])
const [subscriberData,setSubscriberData] = useState([])
const [loading,setLoading] = useState(false)
const [isOpen,setIsOpen] = useState(false)
const [filteredData,setFilteredData] = useState([])

const call_back = (subscriber) => {
  // alert('alert')
  setSubscriberData(subscriber)
  // console.log(data,subscriber)
}
// console.log(data)
const toggle = () => {
  setIsOpen(!isOpen)
}

const sendMail = () => {
  console.log(subscriberData)
try{
  let obj = {
    jobs:filteredData,
    subscribers:[{to:'muhammad.arslan@denovers.com'},{to:'yousuf.shaikh@denovers.com'},{to:'muhammad.sufyan@denovers.com'},{to:'naeemkesrani3@gmail.com'},{to:'rehan.saeed@denovers.com'},{to:'muzammil@denovers.com'}]
  }
  sendNewsLetter(obj)
  // setIsOpen(!isOpen)
}
catch(err){
  console.log(err.message)
}
finally{
  setLoading(true)
}
}

const filtered_data = data => {
   setFilteredData(data)
  // store.dispatch(setFilteredData(data)) 
}

console.log([{subscriberData:''},{sd:'sdsd'}])
  return(

  <Container>
    <Row>
      <Col md={12}>
        <Row>
          <Col>
            <h3 className="page-title">SUBSCRIPTIONS</h3>
          </Col>
          <Col>
            <Button 
            onClick={toggle}
            color='success' className="float-right" > Send Newsletter </Button>
          </Col>
        </Row>

        <Modal isOpen={isOpen} toggle={toggle} style={{maxWidth:'600px'}} >
                  <ModalHeader toggle={toggle} >
                    New Letter Preview
                  </ModalHeader>
                  <ModalBody>
                    <Content
                    filtered_data={filtered_data}/>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      onClick={sendMail}
                      size="sm"
                      disabled={loading}
                    >
                      {loading ? "loading..." : "Send"}
                    </Button>{" "}
                    <Button
                      color="secondary"
                      onClick={toggle}
                      size="sm"
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>

        {/* <h3 className="page-subhead subhead">Use this elements, if you want to show some hints or additional
          information
        </h3> */}
      </Col>
    </Row>
    <Row>
      <Table 
        call_back={call_back}
      />
    </Row>
  </Container>
)
      };

DataTable.propTypes = {
  t: PropTypes.func.isRequired
};


const mapStateToProps = state => {
  console.log(state.jobReducer)
  return {
    news_letter_succes: state.jobReducer.news_letter,  
  }
}
export default connect(mapStateToProps,{sendNewsLetter})(withTranslation("common")(DataTable))
